// /* eslint-disable jsx-a11y/anchor-is-valid */
// import React, { useEffect, useRef, useState } from 'react'
// import ApexCharts, { ApexOptions } from 'apexcharts'
// import { getCSSVariableValue } from '../../../_metronic/assets/ts/_utils'
// import { useThemeMode } from '../../../_metronic/partials'

// type Props = {
//     className: string
//     chartColor: string
//     chartHeight?: string
//     data?: any
//     title?: string
//     subtitle?: string
// }

// const MixedWidget11: React.FC<Props> = ({
//     className,
//     chartColor,
//     chartHeight = '280px',
//     data,
//     title = 'Monthly Overview',
//     subtitle = 'Sales & Purchase'
// }) => {
//     const chartRef = useRef<HTMLDivElement | null>(null)
//     const { mode } = useThemeMode()
//     const [selectedType, setSelectedType] = useState<'sales' | 'purchase'>('sales')

//     const getChartData = () => {
//         const sourceData = selectedType === 'sales'
//             ? data?.monthwiseApprovedSale
//             : data?.monthwiseApprovedPurchase

//         if (!sourceData) {
//             return {
//                 categories: [],
//                 series1: [],
//                 series2: []
//             }
//         }

//         const categories: string[] = []
//         const series1: number[] = []
//         const series2: number[] = []

//         const sortedEntries = Object.entries(sourceData).sort(([a], [b]) => a.localeCompare(b))

//         sortedEntries.forEach(([date, values]: [string, any]) => {
//             const dateObj = new Date(date + '-01')
//             const monthName = dateObj.toLocaleString('default', { month: 'short', year: 'numeric' })
//             categories.push(monthName)
//             series1.push(values[0] || 0)
//             series2.push(values[1] || 0)
//         })

//         return { categories, series1, series2 }
//     }

//     const chartData = getChartData()

//     // Format total quantity in Kg
//     const totalQuantity = chartData.series2.reduce((sum, val) => sum + val, 0)
//     const formattedQuantity = totalQuantity >= 1000
//         ? (totalQuantity / 1000).toFixed(2) + ' Kg'
//         : totalQuantity.toLocaleString() + ' Kg'

//     const refreshChart = () => {
//         if (!chartRef.current) {
//             return
//         }

//         const chart = new ApexCharts(chartRef.current, chartOptions(chartColor, chartHeight, chartData))
//         if (chart) {
//             chart.render()
//         }

//         return chart
//     }

//     useEffect(() => {
//         const chart = refreshChart()

//         return () => {
//             if (chart) {
//                 chart.destroy()
//             }
//         }
//     }, [chartRef, mode, data, selectedType])

//     return (
//         <div className={`card h-70 ${className}`}>
//             <div className='card-body d-flex justify-content-between flex-column overflow-hidden' style={{ padding: '16px' }}>
//                 {/* Header */}
//                 <div className='d-flex flex-stack flex-wrap' style={{ marginBottom: '12px' }}>
//                     <div>
//                         <span className='fw-bold text-gray-800 d-block' style={{ fontSize: '16px' }}>{title}</span>
//                         <span className='text-gray-400 fw-semibold' style={{ fontSize: '12px' }}>{subtitle}</span>
//                     </div>
//                     <div className='d-flex align-items-center gap-2'>
//                         <div className={`fw-bold text-${chartColor}`} style={{ fontSize: '16px' }}>{formattedQuantity}</div>
//                         <select
//                             className='form-select form-select-sm'
//                             style={{
//                                 width: 'auto',
//                                 minWidth: '85px',
//                                 backgroundColor: '#f5f8fa',
//                                 border: '1px solid #e4e6ef',
//                                 borderRadius: '4px',
//                                 padding: '4px 8px',
//                                 fontSize: '11px',
//                                 fontWeight: 500,
//                                 cursor: 'pointer'
//                             }}
//                             value={selectedType}
//                             onChange={(e) => setSelectedType(e.target.value as 'sales' | 'purchase')}
//                         >
//                             <option value='sales'>Sales</option>
//                             <option value='purchase'>Purchase</option>
//                         </select>
//                     </div>
//                 </div>

//                 {/* Chart */}
//                 <div ref={chartRef} style={{ flex: 1, minHeight: '200px' }}></div>
//             </div>
//         </div>
//     )
// }

// const chartOptions = (
//     chartColor: string,
//     chartHeight: string,
//     data: { categories: string[], series1: number[], series2: number[] }
// ): ApexOptions => {
//     const labelColor = getCSSVariableValue('--bs-gray-500')
//     const borderColor = getCSSVariableValue('--bs-gray-200')
//     const secondaryColor = getCSSVariableValue('--bs-gray-300')
//     const baseColor = getCSSVariableValue('--bs-' + chartColor)

//     return {
//         series: [
//             {
//                 name: 'Count',
//                 data: data?.series1 || [],
//             },
//             {
//                 name: 'Quantity (Kg)',
//                 data: data?.series2 || [],
//             },
//         ],
//         chart: {
//             fontFamily: 'inherit',
//             type: 'bar',
//             height: chartHeight,
//             toolbar: {
//                 show: false,
//             },
//         },
//         plotOptions: {
//             bar: {
//                 horizontal: false,
//                 columnWidth: '50%',
//                 borderRadius: 4,
//             },
//         },
//         legend: {
//             show: true,
//             position: 'top',
//             fontSize: '11px',
//             labels: {
//                 colors: labelColor,
//             },
//             itemMargin: {
//                 horizontal: 8,
//                 vertical: 0
//             },
//             markers: {
//                 width: 10,
//                 height: 10
//             }
//         } as any,
//         dataLabels: {
//             enabled: false,
//         },
//         stroke: {
//             show: true,
//             width: 2,
//             colors: ['transparent'],
//         },
//         xaxis: {
//             categories: data?.categories || [],
//             axisBorder: {
//                 show: false,
//             },
//             axisTicks: {
//                 show: false,
//             },
//             labels: {
//                 style: {
//                     colors: labelColor,
//                     fontSize: '11px',
//                 },
//             },
//         },
//         yaxis: [
//             {
//                 seriesName: 'Count',
//                 labels: {
//                     style: {
//                         colors: labelColor,
//                         fontSize: '11px',
//                     },
//                     formatter: function (val: number) {
//                         return Math.round(val).toString()
//                     }
//                 } as any,
//             },
//             {
//                 seriesName: 'Quantity',
//                 opposite: true,
//                 labels: {
//                     style: {
//                         colors: labelColor,
//                         fontSize: '11px',
//                     },
//                     formatter: function (val: number) {
//                         if (val >= 1000) {
//                             return (val / 1000).toFixed(1) + ' Kg'
//                         }
//                         return Math.round(val) + ' Kg'
//                     }
//                 } as any,
//             }
//         ] as any,
//         fill: {
//             type: 'solid',
//         },
//         states: {
//             normal: {
//                 filter: {
//                     type: 'none',
//                     value: 0,
//                 },
//             },
//             hover: {
//                 filter: {
//                     type: 'none',
//                     value: 0,
//                 },
//             },
//             active: {
//                 allowMultipleDataPointsSelection: false,
//                 filter: {
//                     type: 'none',
//                     value: 0,
//                 },
//             },
//         },
//         tooltip: {
//             style: {
//                 fontSize: '11px',
//             },
//             y: {
//                 formatter: function (val: number, { seriesIndex }: any) {
//                     if (seriesIndex === 0) {
//                         return Math.round(val) 
//                     } else {
//                         return val.toLocaleString() + ' Kg'
//                     }
//                 },
//             },
//         },
//         colors: [baseColor, secondaryColor],
//         grid: {
//             padding: {
//                 top: 0,
//                 right: 5,
//                 bottom: 0,
//                 left: 5
//             },
//             borderColor: borderColor,
//             strokeDashArray: 4,
//             yaxis: {
//                 lines: {
//                     show: true,
//                 },
//             },
//         },
//     } as ApexOptions
// }

// export { MixedWidget11 }




/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { getCSSVariableValue } from '../../../_metronic/assets/ts/_utils'
import { useThemeMode } from '../../../_metronic/partials'

type Props = {
    className: string
    chartColor: string
    chartHeight?: string
    data?: any
    title?: string
    subtitle?: string
}

const MixedWidget11: React.FC<Props> = ({
    className,
    chartColor,
    chartHeight = '280px',
    data,
    title = 'Monthly Overview',
    subtitle = 'Sales & Purchase'
}) => {
    const chartRef = useRef<HTMLDivElement | null>(null)
    const { mode } = useThemeMode()
    const [selectedType, setSelectedType] = useState<'sales' | 'purchase' | 'dispatch'>('sales')

    const getChartData = () => {
        let sourceData
        switch (selectedType) {
            case 'sales':
                sourceData = data?.monthwiseApprovedSale
                break
            case 'purchase':
                sourceData = data?.monthwiseApprovedPurchase
                break
            case 'dispatch':
                sourceData = data?.monthwiseDispatched
                break
            default:
                sourceData = data?.monthwiseApprovedSale
        }

        if (!sourceData) {
            return {
                categories: [],
                series1: [],
                series2: []
            }
        }

        const categories: string[] = []
        const series1: number[] = []
        const series2: number[] = []

        const sortedEntries = Object.entries(sourceData).sort(([a], [b]) => a.localeCompare(b))

        sortedEntries.forEach(([date, values]: [string, any]) => {
            const dateObj = new Date(date + '-01')
            const monthName = dateObj.toLocaleString('default', { month: 'short' })
            categories.push(monthName)
            series1.push(values[0] || 0)
            series2.push(values[1] || 0)
        })

        return { categories, series1, series2 }
    }

    const chartData = getChartData()

    // Format total quantity in Kg
    const totalQuantity = chartData.series2.reduce((sum, val) => sum + val, 0)
    const formattedQuantity = totalQuantity >= 1000
        ? (totalQuantity / 1000).toLocaleString('en-In') + ' MT'
        : totalQuantity.toLocaleString('en-In') + ' Kg'

    const refreshChart = () => {
        if (!chartRef.current) {
            return
        }

        const chart = new ApexCharts(chartRef.current, chartOptions(chartColor, chartHeight, chartData))
        if (chart) {
            chart.render()
        }

        return chart
    }

    useEffect(() => {
        const chart = refreshChart()

        return () => {
            if (chart) {
                chart.destroy()
            }
        }
    }, [chartRef, mode, data, selectedType])

    return (
        <div className={`card h-70 ${className}`}>
            <div className='card-body d-flex justify-content-between flex-column overflow-hidden' style={{ padding: '16px' }}>
                {/* Header */}
                <div className='d-flex flex-stack flex-wrap' style={{ marginBottom: '12px' }}>
                    <div>
                        <span className='fw-bold text-gray-800 d-block' style={{ fontSize: '16px' }}>{title}</span>
                        <span className='text-gray-900 fw-semibold' style={{ fontSize: '12px' }}>{subtitle}</span>
                    </div>
                    <div className='d-flex align-items-center gap-2'>
                        <div className={`fw-bold text-${chartColor}`} style={{ fontSize: '16px' }}>{formattedQuantity}</div>
                        <select
                            className='form-select form-select-sm'
                            style={{
                                width: 'auto',
                                minWidth: '85px',
                                backgroundColor: '#f5f8fa',
                                border: '1px solid #e4e6ef',
                                borderRadius: '4px',
                                padding: '4px 8px',
                                fontSize: '11px',
                                fontWeight: 500,
                                cursor: 'pointer'
                            }}
                            value={selectedType}
                            onChange={(e) => setSelectedType(e.target.value as 'sales' | 'purchase' | 'dispatch')}
                        >
                            <option value='sales'>Sales</option>
                            <option value='purchase'>Purchase</option>
                            <option value='dispatch'>Dispatch</option>
                        </select>
                    </div>
                </div>

                {/* Chart */}
                <div ref={chartRef} style={{ flex: 1, minHeight: '200px' }}></div>
            </div>
        </div>
    )
}

const chartOptions = (
    chartColor: string,
    chartHeight: string,
    data: { categories: string[], series1: number[], series2: number[] }
): ApexOptions => {
    const labelColor = getCSSVariableValue('--bs-gray-900')
    const borderColor = getCSSVariableValue('--bs-gray-200')
    const secondaryColor = getCSSVariableValue('--bs-gray-300')
    const baseColor = getCSSVariableValue('--bs-' + chartColor)

    return {
        series: [
            {
                name: 'Count',
                data: data?.series1 || [],
            },
            {
                name: 'Quantity (Kg)',
                data: data?.series2 || [],
            },
        ],
        chart: {
            fontFamily: 'inherit',
            type: 'bar',
            height: chartHeight,
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '50%',
                borderRadius: 4,
            },
        },
        legend: {
            show: true,
            position: 'top',
            fontSize: '11px',
            labels: {
                colors: labelColor,
            },
            itemMargin: {
                horizontal: 8,
                vertical: 0
            },
            markers: {
                width: 10,
                height: 10
            }
        } as any,
        dataLabels: {
            enabled: false,
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent'],
        },
        xaxis: {
            categories: data?.categories || [],
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            labels: {
                style: {
                    colors: labelColor,
                    fontSize: '11px',
                },
            },
        },
        yaxis: [
            {
                seriesName: 'Count',
                labels: {
                    style: {
                        colors: labelColor,
                        fontSize: '11px',
                    },
                    formatter: function (val: number) {
                        return Math.round(val).toString()
                    }
                } as any,
            },
            {
                seriesName: 'Quantity',
                opposite: true,
                labels: {
                    style: {
                        colors: labelColor,
                        fontSize: '11px',
                    },
                    formatter: function (val: number) {
                        if (val >= 1000) {
                            return (val / 1000).toFixed(1) + ' Kg'
                        }
                        return Math.round(val) + ' Kg'
                    }
                } as any,
            }
        ] as any,
        fill: {
            type: 'solid',
        },
        states: {
            normal: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            hover: {
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
            active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                    type: 'none',
                    value: 0,
                },
            },
        },
        tooltip: {
            style: {
                fontSize: '11px',
            },
            y: {
                formatter: function (val: number, { seriesIndex }: any) {
                    if (seriesIndex === 0) {
                        return Math.round(val)
                    } else {
                        return val.toLocaleString('en-In') + ' Kg'
                    }
                },
            },
        },
        colors: [baseColor, secondaryColor],
        grid: {
            padding: {
                top: 0,
                right: 5,
                bottom: 0,
                left: 5
            },
            borderColor: borderColor,
            strokeDashArray: 4,
            yaxis: {
                lines: {
                    show: true,
                },
            },
        },
    } as ApexOptions
}

export { MixedWidget11 }